<template>
  <div class="main">
    <div id="bg">
      <div
        style="height:120px;font-size:40px;font-weight:bold;text-align:center;padding-top:5px;letter-spacing:5px;line-height:120px"
      ></div>
      <div class="navzhi" @click="gozhi"></div>
      <div class="navhui" @click="gozhihui"></div>
      <div class="navyuan" @click="goyuan"></div>
      <div class="navliu" @click="goliu"></div>
      <div class="navhhht" @click="gohhht"></div>
      <div class="navcz" @click="gocz"></div>
      <div class="navyin" @click="goyin"></div>
      <div class="chart01" id="myChart01"></div>
      <div class="chart02" id="myChart02"></div>
      <div class="chart1" v-if="false">
        <div class="myChart">
          <div id="myChart1" style="height:260px;width:100%"></div>
        </div>
      </div>
      <div class="chart2" v-if="false">
        <div class="myChart">
          <div id="myChart2" style="height:260px;width:100%"></div>
        </div>
      </div>
      <div class="chart3" v-if="false">
        <div class="myChart">
          <div id="myChart3" style="height:260px;width:100%"></div>
        </div>
      </div>
      <div class="chart4">
        <div id="myChart4" style="height:100%;width:100%"></div>
      </div>
      <div class="chart5" v-if="false">
        <div id="myChart5" style="height:100%;width:100%"></div>
      </div>
      <div class="chart6">
        <div id="myChart6" style="height:100%;width:100%"></div>
      </div>
      <div class="chart7" v-if="false">
        <div id="myChart7" style="height:100%;width:100%"></div>
      </div>
      <div class="chart8" v-if="false">
        <div id="myChart8" style="height:100%;width:100%"></div>
      </div>
      <!-- 知识库 -->
      <div class="repository" v-if="false">
        <span style="position:relative;top:32px;left:64px;">3757</span>
        <span style="position:relative;top:74px;left:-10px;">2294</span>
        <span style="position:relative;top:115px;left:-30px">537</span>
        <span style="position:relative;top:159px;left:-50px">1867</span>
        <span style="position:relative;top:33px;left:380px">1867</span>
        <span style="position:relative;top:74px;left: 359px;">4875</span>
        <span style="position:relative;top:115px;left:324px">1085</span>
        <span style="position:relative;top:159px;left:250px">5792</span>
      </div>
      <!-- 词云图 -->
      <div class="wordCloud" id="wordCloud">
        <!-- <highcharts :options="options"></highcharts> -->
      </div>
    </div>
    <!-- 天气 -->
    <div class="weather" v-if="false">
      <div
        style="position:relative;width:100%;height:40px;lineHeight:40px;font-size:40px;text-align:center;top:25px;letter-spacing:2px;"
      >内蒙古自治区</div>
      <el-row
        style="position:relative;top:36px;text-align:center;letter-spacing:2px;font-size:13px;"
      >
        <el-col :span="24">局部多云</el-col>
      </el-row>
      <el-row
        style="position:relative;top:30px;text-align:center;letter-spacing:2px;font-size:80px;"
      >
        <el-col :span="24">27</el-col>
      </el-row>
      <el-row style="position:relative;top:40px;letter-spacing:2px;">
        <el-col :span="4" offset="1" style="font-size:14px;lineHeight:26px;">星期三</el-col>
        <el-col :span="3" offset="1" style="font-size:14px;lineHeight:26px;">今天</el-col>
        <el-col :span="3" offset="8" style="font-size:14px;lineHeight:26px;">28</el-col>
        <el-col :span="2" style="font-size:14px;lineHeight:26px;">16</el-col>
      </el-row>

      <el-row
        type="flex"
        justify="space-around"
        style="position:relative;top:60px;width:90%;margin-left:5%;font-size:14px;lineHeight:26px;"
      >
        <el-col :span="4">现在</el-col>
        <el-col :span="4">16时</el-col>
        <el-col :span="4">17时</el-col>
        <el-col :span="4">18时</el-col>
        <el-col :span="4">19时</el-col>
        <el-col :span="4">20时</el-col>
      </el-row>

      <el-row
        type="flex"
        justify="space-around"
        style="position:relative;top:68px;width:90%;margin-left:5%;"
      >
        <el-col :span="4">
          <span class="iconfont icon-tianqi"></span>
        </el-col>
        <el-col :span="4">
          <span class="iconfont icon-yin"></span>
        </el-col>
        <el-col :span="4">
          <span class="iconfont icon-yin"></span>
        </el-col>
        <el-col :span="4">
          <span class="iconfont icon-yin"></span>
        </el-col>
        <el-col :span="4">
          <span class="iconfont icon-yin"></span>
        </el-col>
        <el-col :span="4">
          <span class="iconfont icon-yin"></span>
        </el-col>
      </el-row>

      <el-row
        type="flex"
        justify="space-around"
        style="position:relative;top:74px;width:90%;margin-left:7%;font-size:14px;"
      >
        <el-col :span="4">27</el-col>
        <el-col :span="4">27</el-col>
        <el-col :span="4">26</el-col>
        <el-col :span="4">25</el-col>
        <el-col :span="4">23</el-col>
        <el-col :span="4">23</el-col>
      </el-row>

      <el-row style="position:relative;top:90px;letter-spacing:2px;">
        <el-col :span="4" offset="1" style="font-size:18px;">星期四</el-col>
        <el-col :span="3" offset="5">
          <i
            class="iconfont icon-tianqi-qing"
            style="color:#f6f630;font-size:26px;margin-left:5px;"
          ></i>
        </el-col>
        <el-col :span="3" offset="4" style="font-size:14px">29</el-col>
        <el-col :span="2" style="font-size:14px">12</el-col>
      </el-row>

      <el-row style="position:relative;top:94px;letter-spacing:2px;">
        <el-col :span="4" offset="1" style="font-size:18px;">星期五</el-col>
        <el-col :span="3" offset="5">
          <i
            class="iconfont icon-tianqi-qing"
            style="color:#f6f630;font-size:26px;margin-left:5px;"
          ></i>
        </el-col>
        <el-col :span="3" offset="4" style="font-size:14px">29</el-col>
        <el-col :span="2" style="font-size:14px">12</el-col>
      </el-row>
    </div>

    <!-- 操作员口令 -->
    <dialog
      :open="commandShow"
      style="width:100%;height:100%;backgroundColor:rgba(0,0,0,0.3);z-index:1000"
    >
      <div class="command">
        <div style="text-align:center;font-size:36px;margin-top:50px;letter-spacing:5px;">操作员口令</div>
        <el-input
          class="koulinginput"
          prefix-icon="iconfont icon-suo"
          v-model="input1"
          style="width:500px;margin-top:50px;"
        ></el-input>
        <br />
        <button
          style="width:500px;margin-top:50px;color:#ffffff;background:#48cce5;height:70px;font-size:24px;letter-spacing:4px;border:none;"
          @click="commandClick"
        >进入</button>
      </div>
    </dialog>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
export default {
  name: "Index",
  components: {
    G2World
  },
  data() {
    return {
      serverData: [],
      commandShow: false, //操作员口令
      input1: "",
      options: {
        chart: {
          type: "packedbubble",
          height: "100%"
        },
        title: {
          text: "2014 年世界各地碳排放量"
        },
        tooltip: {
          useHTML: true,
          pointFormat: "<b>{point.name}:</b> {point.y}m CO<sub>2</sub>"
        },
        plotOptions: {
          packedbubble: {
            minSize: "30%",
            maxSize: "120%",
            zMin: 0,
            zMax: 1000,
            layoutAlgorithm: {
              splitSeries: false,
              gravitationalConstant: 0.02
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              filter: {
                property: "y",
                operator: ">",
                value: 250
              },
              style: {
                color: "black",
                textOutline: "none",
                fontWeight: "normal"
              }
            }
          }
        },
        series: [
          {
            name: "欧洲",
            data: [
              {
                name: "Germany",
                value: 767.1
              },
              {
                name: "Croatia",
                value: 20.7
              },
              {
                name: "Belgium",
                value: 97.2
              },
              {
                name: "Czech Republic",
                value: 111.7
              },
              {
                name: "Netherlands",
                value: 158.1
              },
              {
                name: "Spain",
                value: 241.6
              },
              {
                name: "Ukraine",
                value: 249.1
              },
              {
                name: "Poland",
                value: 298.1
              },
              {
                name: "France",
                value: 323.7
              },
              {
                name: "Romania",
                value: 78.3
              },
              {
                name: "United Kingdom",
                value: 415.4
              },
              {
                name: "Turkey",
                value: 353.2
              },
              {
                name: "Italy",
                value: 337.6
              },
              {
                name: "Greece",
                value: 71.1
              },
              {
                name: "Austria",
                value: 69.8
              },
              {
                name: "Belarus",
                value: 67.7
              },
              {
                name: "Serbia",
                value: 59.3
              },
              {
                name: "Finland",
                value: 54.8
              },
              {
                name: "Bulgaria",
                value: 51.2
              },
              {
                name: "Portugal",
                value: 48.3
              },
              {
                name: "Norway",
                value: 44.4
              },
              {
                name: "Sweden",
                value: 44.3
              },
              {
                name: "Hungary",
                value: 43.7
              },
              {
                name: "Switzerland",
                value: 40.2
              },
              {
                name: "Denmark",
                value: 40
              },
              {
                name: "Slovakia",
                value: 34.7
              },
              {
                name: "Ireland",
                value: 34.6
              },
              {
                name: "Croatia",
                value: 20.7
              },
              {
                name: "Estonia",
                value: 19.4
              },
              {
                name: "Slovenia",
                value: 16.7
              },
              {
                name: "Lithuania",
                value: 12.3
              },
              {
                name: "Luxembourg",
                value: 10.4
              },
              {
                name: "Macedonia",
                value: 9.5
              },
              {
                name: "Moldova",
                value: 7.8
              },
              {
                name: "Latvia",
                value: 7.5
              },
              {
                name: "Cyprus",
                value: 7.2
              }
            ]
          },
          {
            name: "非洲",
            data: [
              {
                name: "Senegal",
                value: 8.2
              },
              {
                name: "Cameroon",
                value: 9.2
              },
              {
                name: "Zimbabwe",
                value: 13.1
              },
              {
                name: "Ghana",
                value: 14.1
              },
              {
                name: "Kenya",
                value: 14.1
              },
              {
                name: "Sudan",
                value: 17.3
              },
              {
                name: "Tunisia",
                value: 24.3
              },
              {
                name: "Angola",
                value: 25
              },
              {
                name: "Libya",
                value: 50.6
              },
              {
                name: "Ivory Coast",
                value: 7.3
              },
              {
                name: "Morocco",
                value: 60.7
              },
              {
                name: "Ethiopia",
                value: 8.9
              },
              {
                name: "United Republic of Tanzania",
                value: 9.1
              },
              {
                name: "Nigeria",
                value: 93.9
              },
              {
                name: "South Africa",
                value: 392.7
              },
              {
                name: "Egypt",
                value: 225.1
              },
              {
                name: "Algeria",
                value: 141.5
              }
            ]
          },
          {
            name: "大洋洲",
            data: [
              {
                name: "Australia",
                value: 409.4
              },
              {
                name: "New Zealand",
                value: 34.1
              },
              {
                name: "Papua New Guinea",
                value: 7.1
              }
            ]
          },
          {
            name: "北美洲",
            data: [
              {
                name: "Costa Rica",
                value: 7.6
              },
              {
                name: "Honduras",
                value: 8.4
              },
              {
                name: "Jamaica",
                value: 8.3
              },
              {
                name: "Panama",
                value: 10.2
              },
              {
                name: "Guatemala",
                value: 12
              },
              {
                name: "Dominican Republic",
                value: 23.4
              },
              {
                name: "Cuba",
                value: 30.2
              },
              {
                name: "USA",
                value: 5334.5
              },
              {
                name: "Canada",
                value: 566
              },
              {
                name: "Mexico",
                value: 456.3
              }
            ]
          },
          {
            name: "南美洲",
            data: [
              {
                name: "El Salvador",
                value: 7.2
              },
              {
                name: "Uruguay",
                value: 8.1
              },
              {
                name: "Bolivia",
                value: 17.8
              },
              {
                name: "Trinidad and Tobago",
                value: 34
              },
              {
                name: "Ecuador",
                value: 43
              },
              {
                name: "Chile",
                value: 78.6
              },
              {
                name: "Peru",
                value: 52
              },
              {
                name: "Colombia",
                value: 74.1
              },
              {
                name: "Brazil",
                value: 501.1
              },
              {
                name: "Argentina",
                value: 199
              },
              {
                name: "Venezuela",
                value: 195.2
              }
            ]
          },
          {
            name: "亚洲",
            data: [
              {
                name: "Nepal",
                value: 6.5
              },
              {
                name: "Georgia",
                value: 6.5
              },
              {
                name: "Brunei Darussalam",
                value: 7.4
              },
              {
                name: "Kyrgyzstan",
                value: 7.4
              },
              {
                name: "Afghanistan",
                value: 7.9
              },
              {
                name: "Myanmar",
                value: 9.1
              },
              {
                name: "Mongolia",
                value: 14.7
              },
              {
                name: "Sri Lanka",
                value: 16.6
              },
              {
                name: "Bahrain",
                value: 20.5
              },
              {
                name: "Yemen",
                value: 22.6
              },
              {
                name: "Jordan",
                value: 22.3
              },
              {
                name: "Lebanon",
                value: 21.1
              },
              {
                name: "Azerbaijan",
                value: 31.7
              },
              {
                name: "Singapore",
                value: 47.8
              },
              {
                name: "Hong Kong",
                value: 49.9
              },
              {
                name: "Syria",
                value: 52.7
              },
              {
                name: "DPR Korea",
                value: 59.9
              },
              {
                name: "Israel",
                value: 64.8
              },
              {
                name: "Turkmenistan",
                value: 70.6
              },
              {
                name: "Oman",
                value: 74.3
              },
              {
                name: "Qatar",
                value: 88.8
              },
              {
                name: "Philippines",
                value: 96.9
              },
              {
                name: "Kuwait",
                value: 98.6
              },
              {
                name: "Uzbekistan",
                value: 122.6
              },
              {
                name: "Iraq",
                value: 139.9
              },
              {
                name: "Pakistan",
                value: 158.1
              },
              {
                name: "Vietnam",
                value: 190.2
              },
              {
                name: "United Arab Emirates",
                value: 201.1
              },
              {
                name: "Malaysia",
                value: 227.5
              },
              {
                name: "Kazakhstan",
                value: 236.2
              },
              {
                name: "Thailand",
                value: 272
              },

              {
                name: "Indonesia",
                value: 453
              },
              {
                name: "Saudi Arabia",
                value: 494.8
              },
              {
                name: "Japan",
                value: 1278.9
              },
              {
                name: "China",
                value: 10540.8
              },
              {
                name: "India",
                value: 2341.9
              },
              {
                name: "Russia",
                value: 1766.4
              },
              {
                name: "Iran",
                value: 618.2
              },
              {
                name: "Korea",
                value: 610.1
              }
            ]
          }
        ]
      }
    };
  },
  props: {},
  mounted: function () {
    //this.myChart1();
    //this.myChart2();
    //this.myChart3();
    this.myChart4();
    //this.myChart5();
    this.myChart6();
    //this.myChart7();
    //this.myChart8();
    this.myChart01();
    this.myChart02();
    // this.myWordCloud();
    this.buttle();
  },
  methods: {
    //  气泡图
    buttle() {
      Highcharts.chart("wordCloud", {
        chart: {
          type: "packedbubble",
          // height: "100%",
          height: 460,
          marginTop: 0,
          marginBottom: 0,
          backgroundColor: "rgba(5,32,55,0.1)"
        },
        colors: [
          "#bf8e95",
          "#409db1",
          "#5da4d6",
          "#c26886",
          "#8971b0",
          "#60bfa0",
          "#6a76b7"
        ],
        title: {
          text: null
        },
        legend: {
          enabled: false //不显示图例
        },
        pane: {
          size: "100%"
        },
        credits: {
          enabled: false //不显示LOGO
        },
        tooltip: {
          useHTML: true,
          pointFormat: "<b>{point.y}</b>"
        },
        plotOptions: {
          packedbubble: {
            minSize: "60%",
            maxSize: "120%",
            zMin: 0,
            zMax: 1000,
            layoutAlgorithm: {
              splitSeries: false, //是否开启外边的大圆
              gravitationalConstant: 0.01
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              style: {
                color: "#ffffff",
                textOutline: "none",
                fontWeight: "normal",
                fontSize: "18px"
              }
            }
          }
        },
        series: [
          {
            name: "群众举报",
            data: [
              {
                name: "群众举报",
                value: 7.2
              }
            ]
          },
          {
            name: "上级指定",
            data: [
              {
                name: "上级指定",
                value: 141.5
              }
            ]
          },
          {
            name: "行政机关",
            data: [
              {
                name: "行政机关",
                value: 820.1
              }
            ]
          },
          {
            name: "检察机关移送",
            data: [
              {
                name: "检察机关移送",
                value: 156.3
              }
            ]
          },
          {
            name: "线索预留",
            data: [
              {
                name: "线索预留",
                value: 195.2
              }
            ]
          },
          {
            name: "互联网",
            data: [
              {
                name: "互联网",
                value: 510.1
              }
            ]
          },
          {
            name: "专项督查",
            data: [
              {
                name: "专项督查",
                value: 310.1
              }
            ]
          },
          {
            name: "铁路局提供",
            data: [
              {
                name: "铁路局提供",
                value: 100.1
              }
            ]
          }
        ]
      });
    },
    gozhihui() {
      this.$router.push({ path: "/zhihui" });
    },
    gozhi() {
      this.$router.push({ path: "/Zhi" });
    },
    goyuan() {
      this.$router.push({ path: "/yuan" });
    },
    goliu() {
      this.$router.push({ path: "/liu" });
    },
    gohhht() {
      this.$router.push({ path: "/hhht" });
    },
    goyin() {
      this.$router.push({ path: "/yin" });
    },
    gocz() {
      // this.$router.push({ path: "/cz" });
      window.location.href = "/#/cz";
    },
    myChart01() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart01"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: [
          "#21acab",
          "#9c7f77",
          "#9c9864",
          "#6954a2",
          "#99ab62",
          "#3d5da6",
          "#30846f",
          "#3e58a8"
        ],
        grid: {
          left: -20,
          top: 0,
          bottom: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        polar: {},
        angleAxis: {
          type: "category",
          data: [
            {
              value: "行政机关",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "上级指定",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "预警线索",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "检察机关移送",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "专项督查",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "路局提供",
              textStyle: {
                fontSize: 12
              }
            },
            {
              value: "群众举报",
              textStyle: {
                fontSize: 12
              }
            }
          ],
          axisLabel: {
            margin: 12
          },
          z: 10,
          axisTick: {
            length: 20,
            lineStyle: {
              color: "#84e0ef"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#84e0ef",
              type: "solid"
            }
          }
        },
        radiusAxis: {
          min: 0,
          max: 50,
          interval: 10,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0B3E5E",
              width: 1,
              type: "solid"
            }
          },
          zlevel: 1,
          z: 9999999,
          axisLabel: {
            formatter: "{value} %",
            show: true,
            padding: [0, -40, 20, 0],
            color: "#ffffff",
            fontSize: 18
          },
          splitLine: {
            lineStyle: {
              color: "#84e0ef",
              width: 2,
              type: "solid"
            }
          }
        },
        calculable: true,
        series: [
          {
            type: "pie",
            radius: ["15%", "20%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              },
              emphasis: {
                show: false
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#84e0ef"
                  }
                }
              }
            ]
          },
          {
            stack: "a",
            type: "pie",
            radius: ["20%", "80%"],
            roseType: "area",
            label: {
              normal: {
                show: false,
                formatter: "{c}",
                textStyle: {
                  fontSize: 18
                },
                position: "outside"
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 55
              },
              emphasis: {
                show: false
              }
            },
            data: [
              {
                value: 10,
                name: "行政机关"
              },
              {
                value: 5,
                name: "上级指定"
              },
              {
                value: 15,
                name: "互联网"
              },
              {
                value: 25,
                name: "预警线索"
              },
              {
                value: 20,
                name: "检察机关"
              },
              {
                value: 30,
                name: "专项督查"
              },
              {
                value: 28,
                name: "路局提供"
              },
              {
                value: 35,
                name: "群众举报"
              }
            ]
          }
        ]
      });
    },
    myChart02() {
      //数据
      var data = {
        total: 280,
        data: [
          { name: "线索受理数", value: 34 },
          { name: "诉前程序数", value: 68 },
          { name: "检察建议", value: 56 },
          { name: "起诉数", value: 90 }
        ]
      };
      var labelData = [];
      var scale = 64 / data.total;
      var totalNum = data.total * scale;
      var step1 = data.data[0].value * scale;
      var step2 = step1 + data.data[1].value * scale;
      var step3 = step2 + data.data[2].value * scale;
      for (var i = 0; i <= totalNum; i++) {
        switch (true) {
          case i < step1:
            labelData.push({
              value: 1,
              name: data.data[0],
              itemStyle: {
                normal: {
                  color: "#e4475f"
                }
              }
            });
            break;
          case step1 < i && i < step2:
            labelData[i] = {
              value: 1,
              name: data.data[1],
              itemStyle: {
                normal: {
                  color: "#3ed587"
                }
              }
            };
            break;
          case step2 < i && i < step3:
            labelData[i] = {
              value: 1,
              name: data.data[2],
              itemStyle: {
                normal: {
                  color: "#8d6da7"
                }
              }
            };
            break;
          case step3 < i && i < totalNum:
            labelData[i] = {
              value: 1,
              name: data.data[3],
              itemStyle: {
                normal: {
                  color: "#00c4e6"
                }
              }
            };
            break;
        }
      }
      let myChart = this.$echarts.init(document.getElementById("myChart02"));
      myChart.setOption({
        tooltip: {
          show: false,
          position: [0, 0],
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        grid: {
          left: 0,
          top: "10%",
          bottom: 0,
          right: 0
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "25%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#01b8d9"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            radius: ["30%", "35%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#01b8d9"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            radius: ["60%", "70%"],
            // hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
                length: 30,
                length2: 55
              }
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#0f3c55"
                  }
                }
              }
            ]
          },
          {
            type: "pie",
            // hoverAnimation: false,
            // color: ["#FF0000", "#FF7900", "#F1C000", "#0068FF"],
            // 'radius': [55, 80],
            radius: ["60%", "70%"],
            startAngle: 30,
            label: {
              normal: {
                formatter: function (params) {
                  return (
                    // "" +
                    // params.name +
                    // "(" +
                    // params.value +
                    // ")" +
                    // "\n" +
                    // params.percent +
                    // "%"
                    params.value
                  );
                },
                show: true,
                textStyle: {
                  fontSize: "18",
                  color: "#fff"
                },
                padding: [-20, 0, 0, 0]
              }
            },
            labelLine: {
              show: true,
              normal: {
                lineStyle: {
                  width: 2
                },
                smooth: 0.2,
                length: 5,
                length2: 20
              }
            },
            data: data.data,
            z: 1
          },
          {
            type: "pie",
            // hoverAnimation: false,
            // color: ["#FF0000", "#FF7900", "#F1C000", "#0068FF"],
            // 'radius': [55, 80],
            radius: ["60%", "70%"],
            startAngle: 30,
            label: {
              normal: {
                formatter: function (params) {
                  return params.name;
                },
                show: true,
                textStyle: {
                  fontSize: "18",
                  color: "#fff"
                },
                padding: [20, 0, 0, 0]
              }
            },
            labelLine: {
              show: true,
              normal: {
                lineStyle: {
                  width: 2
                },
                smooth: 0.2,
                length: 5,
                length2: 20
              }
            },
            data: data.data,
            z: 1
          },
          {
            // hoverAnimation: true,
            // 'avoidLabelOverlap': true,
            type: "pie",
            data: labelData,
            startAngle: 30,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "rgb(41, 60, 85)"
              }
            },
            labelLine: {
              show: false
            },
            radius: [60, 90],
            label: {
              normal: {
                show: false
              }
            },
            z: 2
          }
        ]
      });
    },
    myWordCloud() {
      var worldCloudcharts = this.$echarts.init(
        document.getElementById("myWordCloud")
      );
      var worldCloudoption = {
        tooltip: {
          show: true
        },
        series: [
          {
            name: "采集来源",
            type: "wordCloud",
            sizeRange: [18, 32],
            rotationRange: [0, 0],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 6
            },
            textStyle: {
              normal: {
                color: "#ffffff"
              },
              emphasis: {
                show: false
              }
            },
            data: []
          }
        ]
      };

      var JosnList = [];

      JosnList.push(
        {
          name: "群众举报",
          value: "20"
        },
        {
          name: "行政机关",
          value: "26"
        },
        {
          name: "上级指定",
          value: "11"
        },
        {
          name: "检察机关移送",
          value: "11"
        },
        {
          name: "线索预留",
          value: "11"
        },
        {
          name: "互联网",
          value: "11"
        },
        {
          name: "专项督查",
          value: "11"
        },
        {
          name: "铁路局提供",
          value: "11"
        }
      );
      worldCloudoption.series[0].data = JosnList;

      worldCloudcharts.setOption(worldCloudoption);
    },
    myChart2() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart2"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#11ccd3"],
        color: ["#11c8d5"],
        title: {
          text: "近一月数据采集情况",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "20%",
          left: "0%",
          right: "3%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["第一周", "第二周", "第三周", "第四周"],
          axisLabel: {
            fontSize: "12"
          },
          axisLabel: {
            color: "#21bffd"
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: "12",
            color: "#868686"
          }
        },
        series: [
          {
            name: "数据",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134],
            areaStyle: {},
            smooth: true
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart3() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart3"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#e9dc81"],
        title: {
          text: "案件来源",
          textStyle: {
            fontSize: "16"
          },
          top: 20
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              fontSize: 12,
              color: "#04a8f2"
            },
            formatter: a => {
              return `${a}`;
            }
          },
          indicator: [
            { name: "行政执法单位", max: 6500 },
            { name: "互联网", max: 16000 },
            { name: "群众举报", max: 30000 },
            { name: "统一业务应用系统", max: 38000 },
            { name: "卫星影像", max: 52000 },
            { name: "其它", max: 25000 }
          ]
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      return params.value;
                    },
                    fontSize: 12,
                    color: "#04a8f2",
                    fontWeight: "bold"
                  }
                },
                itemStyle: {
                  color: "#e9dc81"
                }
              }
            ]
          }
        ]
      });
    },
    myChart7() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart7"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          data: ["民事公益诉讼", "行政公益诉讼"],
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{b}\n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "民事公益诉讼" },
              { value: 310, name: "行政公益诉讼" }
            ]
          }
        ]
      });
    },
    myChart5() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart5"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: [
          "#00dc9b",
          "#0566d4",
          "#dbff0d",
          "#97adfc",
          "#0bca25",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          type: "scroll",
          data: [
            "国有土地使用权",
            "国有财产保护",
            "生态资源与环境保护",
            "食品与药品安全",
            "英烈保护"
          ],
          bottom: 10,
          left: "center"
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["0%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{d}%"
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [
              { value: 335, name: "国有土地使用权" },
              { value: 310, name: "国有财产保护" },
              { value: 274, name: "生态资源与环境保护" },
              { value: 235, name: "食品与药品安全" },
              { value: 400, name: "英烈保护" }
            ]
          }
        ]
      });
    },
    myChart6() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart6"),
        "dark"
      );
      //app.title = "水印 - ECharts 下载统计";

      var builderJson = {
        all: 10887,
        charts: {
          恢复污染总面积: 3237,
          整治违法排放企业: 2164,
          整治违法食品药品企业: 7561,
          注销违法食品药品经营许可证: 7778,
          整治被污染河道: 7355,
          整治非法占用的河道: 2405
        },
        components: {
          geo: 2788,
          title: 9575,
          legend: 9400,
          tooltip: 9466,
          grid: 9266,
          markPoint: 3419,
          markLine: 2984,
          timeline: 2739,
          dataZoom: 2744,
          visualMap: 2466,
          toolbox: 3034,
          polar: 1945
        },
        ie: 9743
      };

      var downloadJson = {
        "echarts.min.js": 17365,
        "echarts.simple.min.js": 4079,
        "echarts.common.min.js": 6929,
        "echarts.js": 14890
      };

      var themeJson = {
        "dark.js": 1594,
        "infographic.js": 925,
        "shine.js": 1608,
        "roma.js": 721,
        "macarons.js": 2179,
        "vintage.js": 1982
      };

      var waterMarkText = "ECHARTS";

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      canvas.width = canvas.height = 100;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.globalAlpha = 0.08;
      ctx.font = "20px Microsoft Yahei";
      ctx.translate(50, 50);
      ctx.rotate(-Math.PI / 4);
      ctx.fillText(waterMarkText, 0, 0);
      var size = [16, 40, 12, 13, 55, 18, 30, 50];
      myChart.setOption({
        color: ["#64cdcb"],
        backgroundColor: {
          type: "pattern",
          image: canvas,
          repeat: "repeat"
        },
        grid: {
          left: 145
        },
        tooltip: {},
        xAxis: [
          {
            type: "value",
            max: builderJson.all,
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "category",
            data: Object.keys(builderJson.charts),
            axisLabel: {
              interval: 0,
              rotate: 30
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            type: "bar",
            stack: "chart",
            z: 3,
            label: {
              normal: {
                position: "right",
                show: true
              }
            },
            data: Object.keys(builderJson.charts).map(function (key) {
              return builderJson.charts[key];
            })
          },
          {
            type: "bar",
            stack: "chart",
            silent: true,
            itemStyle: {
              normal: {
                color: "#123b53"
              }
            },
            data: Object.keys(builderJson.charts).map(function (key) {
              return builderJson.all - builderJson.charts[key];
            })
          }
        ]
      });
    },
    myChart4() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart4"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 4
        },
        color: ["#4fa3af", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["2016", "2017", "2018", "2019"],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 16
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 16
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            itemStyle: {
              barBorderRadius: 10
            },
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
              [
                { offset: 0, color: "#288fa7" },
                { offset: 0.5, color: "#318688" },
                { offset: 1, color: "#3b7d66" }
              ] //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
            ),
            barWidth: "8%",
            type: "bar",
            data: [4100, 6100, 8100, 7500]
          },
          {
            name: "国有土地使用权出让",
            itemStyle: {
              barBorderRadius: 10
            },
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
              [
                { offset: 0, color: "#7d6195" },
                { offset: 0.5, color: "#5a707c" },
                { offset: 1, color: "#3c7d66" }
              ] //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
            ),
            barWidth: "8%",
            type: "bar",
            data: [8000, 4500, 4600, 3800]
          },
          {
            name: "生态资源",
            itemStyle: {
              barBorderRadius: 10
            },
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
              [
                { offset: 0, color: "#3a972c" },
                { offset: 0.5, color: "#3a8a48" },
                { offset: 1, color: "#3b7d64" }
              ] //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
            ),
            barWidth: "8%",
            type: "bar",
            data: [6300, 6400, 7800, 6200]
          },
          {
            name: "国有财产",
            itemStyle: {
              barBorderRadius: 10
            },
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
              [
                { offset: 0, color: "#c35274" },
                { offset: 0.5, color: "#83656d" },
                { offset: 1, color: "#3e7c66" }
              ] //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
            ),
            barWidth: "8%",
            type: "bar",
            data: [3800, 4100, 4200, 2500]
          },
          {
            name: "英烈权益",
            itemStyle: {
              barBorderRadius: 10
            },
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
              [
                { offset: 0, color: "#afce01" },
                { offset: 0.5, color: "#74a434" },
                { offset: 1, color: "#3d7e64" }
              ] //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
            ),
            barWidth: "8%",
            type: "bar",
            data: [4500, 3000, 4300, 5500]
          },
          {
            name: "案例平均值",
            type: "line",
            smooth: true,
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: "#d24d57"
              }
            },
            lineStyle: {
              width: 2
            },
            data: [2000, 3000, 4000, 5000]
          },
          {
            name: "线索平均值",
            type: "line",
            smooth: true,
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: "#8accc6"
              }
            },
            lineStyle: {
              width: 2
            },
            data: [5000, 4000, 3000, 2000]
          }
        ]
      });
    },
    myChart8() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart8"),
        "dark"
      );
      let that = this;
      var size = [16, 40, 12, 13, 55, 18, 30, 50];

      const file = "/static/neimenggu.json";
      that.$axios.get(file).then(response => {
        this.$echarts.registerMap("neimenggu", response.data);
        myChart.setOption({
          backgroundColor: "",
          title: {
            text: "",
            textStyle: {
              fontSize: 16
            }
          },
          geo3D: {
            map: "neimenggu",
            height: 511,
            width: 690,
            label: {
              show: true,
              emphasis: {
                show: true
              },
              textStyle: {
                color: "#000",
                fontSize: 14,
                backgroundColor: "rgba(0,23,11,0)"
              }
            },
            viewControl: {
              zoomSensitivity: 0,
              panSensitivity: 0,
              rotateSensitivity: 0,
              alpha: 50,
              orthographicSize: 300
            },
            //shading :"color",
            emphasis: {
              //当鼠标放上去  地区区域是否显示名称
              label: {
                show: true,
                textStyle: {
                  color: "#000",
                  fontSize: 1,
                  backgroundColor: "rgba(0,23,11,0)"
                }
              }
            },
            roam: false, //是否允许缩放
            scaleLimit: {
              min: 1 //定义滚轮缩放的极限控制
            },
            itemStyle: {
              color: "#8df6ff",
              //areaColor: "rgb(141,245,255)",
              opacity: 1,
              borderWidth: 1,
              //borderColor: "rgb(62,215,213)"
              borderColor: "#759fd2"
            }
          },
          light: {
            //光照阴影
            main: {
              color: "#fff", //光照颜色
              intensity: 1.2, //光照强度
              //shadowQuality: 'high', //阴影亮度
              shadow: false, //是否显示阴影
              alpha: 55,
              beta: 10
            }
          },
          series: []
        });
      });
    },
    // 取消蒙太框
    commandClick() {
      this.commandShow = false;
    }
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");

.main {
  background: url("../assets/bg6.png") no-repeat;
  width: 2880px;
  height: 1080px;
}

.border {
  background: url("../assets/border3.png") no-repeat;
  background-size: 100% 300px;
  width: 100%;
  height: 300px;
  padding: 5px 5px;
}

.diqiu {
  background: url("../assets/diqiu.png") no-repeat;
  background-size: 334px 263px;
  background-position: center;
  width: 100%;
  height: 263px;
  padding: 5px 5px;
}
.title {
  font-size: 50px;
}

.navzhi {
  position: absolute;
  left: 1370px;
  top: 480px;
  width: 140px;
  height: 140px;
  cursor: pointer;
  z-index: 1;
  border-radius: 70px;
}

.navhui {
  position: absolute;
  left: 1585px;
  top: 450px;
  width: 120px;
  height: 120px;
  cursor: pointer;
  z-index: 1;
}

.navhhht {
  position: absolute;
  left: 1028px;
  top: 701px;
  width: 834px;
  height: 304px;
  cursor: pointer;
  z-index: 1;
}

.navyuan {
  position: absolute;
  left: 1128px;
  top: 322px;
  width: 92px;
  height: 102px;
  cursor: pointer;
  z-index: 1;
}

.navliu {
  position: absolute;
  left: 1170px;
  top: 450px;
  width: 120px;
  height: 120px;
  cursor: pointer;
  z-index: 1;
}

.navyin {
  position: absolute;
  left: 1652px;
  top: 300px;
  width: 120px;
  height: 120px;
  cursor: pointer;
  z-index: 1;
}

.navcz {
  position: absolute;
  left: 1281px;
  top: 32px;
  width: 66px;
  height: 60px;
  cursor: pointer;
  z-index: 1;
}

.myChart {
  /* border: #ffffff 2px dashed; */
  width: 96%;
  padding: 5px 30px;
}

.border img {
  width: 120px;
  margin-left: 10px;
}

.box-title {
  text-align: left;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 40px;
}

.group {
  background: url("../assets/img_product/group.png") no-repeat;
  width: 450px;
  height: 275px;
  padding-left: 20px;
  margin-left: 50px;
}

.groupnumber {
  color: #75eaff;
}

.groupcontent {
  color: #bccad4;
}

.chart1 {
  position: absolute;
  left: 82px;
  top: 128px;
  width: 316px;
  height: 420px;
  border: 0px solid #ffffff;
}

.chart2 {
  position: absolute;
  left: 421px;
  top: 182px;
  width: 317px;
  height: 434px;
  border: 0px solid #ffffff;
}

.chart3 {
  position: absolute;
  left: 743px;
  top: 391px;
  width: 234px;
  height: 227px;
  border: 0px solid #ffffff;
}

.chart4 {
  position: absolute;
  left: 125px;
  top: 760px;
  width: 784px;
  height: 225px;
}

.chart5 {
  position: absolute;
  left: 1936px;
  top: 436px;
  width: 850px;
  height: 240px;
  border: 0px solid #ffffff;
}

.chart6 {
  position: absolute;
  left: 1999px;
  top: 760px;
  width: 343px;
  height: 254px;
  border: 0px solid #ffffff;
}

.chart7 {
  position: absolute;
  left: 2398px;
  top: 806px;
  width: 165px;
  height: 208px;
  border: 0px solid #ffffff;
}

.chart8 {
  position: absolute;
  left: 2603px;
  top: 812px;
  width: 138px;
  height: 188px;
  border: 0px solid #ffffff;
}
.chart01 {
  position: absolute;
  width: 300px;
  height: 234px;
  top: 350px;
  left: 673px;
  /* background-color: aqua; */
}
.chart02 {
  position: absolute;
  width: 427px;
  height: 245px;
  top: 436px;
  left: 1935px;
  /* background-color: aqua; */
}
/* 知识库 */
.repository {
  position: absolute;
  width: 632px;
  height: 186px;
  top: 166px;
  left: 2160px;
  color: #ff6ab6;
  /* background-color: aqua; */
}
/* 操作员口令 */
.command {
  position: absolute;
  width: 880px;
  height: 440px;
  left: 1000px;
  top: 200px;
  z-index: 1000;
  color: #ffffff;
  background-color: #052d47;
  text-align: center;
  /* background: url("../assets/kouling.png") no-repeat; */
}
.koulinginput /deep/ .el-input__inner {
  height: 70px;
  border-radius: 0;
  border: none;
  color: #ffffff;
  font-size: 24px;
  letter-spacing: 3px;
  padding: 0 80px;
  background-color: #0f5073;
}
.koulinginput /deep/ .el-input__prefix {
  left: 20px;
  color: #ffffff;
}
/deep/ .iconfont {
  font-size: 36px;
}
/* 天气 */
.weather {
  position: absolute;
  width: 360px;
  height: 460px;
  color: #ffffff;
  /* background: #ff6ab6; */
  top: 130px;
  left: 60px;
}
/* 词云图 */
.wordCloud {
  position: absolute;
  width: 300px;
  height: 400px;
  /* background: #ff6ab6; */
  left: 400px;
  top: 160px;
}
</style>
